
// doLogin 
export const doLogin = async (data,docId,next) =>{
    await localStorage.setItem("userBbarna",JSON.stringify(data))
    await localStorage.setItem("userBbarnaDoc",docId)
    next()
}

// isLoggedIn
export const isLoggedIn = () =>{
    let data = localStorage.getItem("userBbarna");
    if(data == null){
        return false;
    } 
    else{
        return true;
    }
}

// doLogout
export const doLogout = (next) =>{
    localStorage.removeItem("userBbarna");
    localStorage.removeItem("userBbarnaDoc");
    next()
}

// get currentUser
export const getCurrentUserDetail = () =>{
    if(isLoggedIn()){
        return JSON.parse(localStorage.getItem("userBbarna"));
    }else{
        return undefined;
    }
}

// get User Doc Id
export const getUserDocId = () =>{
    let data = localStorage.getItem("userBbarnaDoc");
    return data;
}

export const getDeviceCount = () =>{
    let data = JSON.parse(localStorage.getItem("userBbarna"));
    return data;
}